import React from "react";
import AdvertiseProduct from "../components/business/AdvertiseProduct";

function AdvertiseProductPage() {
  return <AdvertiseProduct />;
}

export default AdvertiseProductPage;
